import { StripeData, StripeItemEvents } from 'common/interfaces';
import React from 'react';

export type StripeProps = React.PropsWithChildren<StripeData & StripeItemEvents>;
const Stripe = (props: StripeProps) => {
  return <>{props.children}</>;
};

export default Stripe;
